import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  themes,
  utils,
  Clinic,
  TimeSlot,
  AppointmentType,
  ReduxState,
  PatientState
} from 'kb-shared';
import { LeftBracket, RightBracket, CalendarIcon } from 'kb-web-shared';

const { momentInTimeZone } = utils;
const { colors } = themes;

// Appointment Details Block
const AppointmentBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: white;
  margin-bottom: 28px;
`;

const Content = styled.div`
  padding: 20px;
  display: flex;
  align-items: flex-start;
`;

const AppointmentBlockTitle = styled.div`
  ${themes.fonts.DomaineDisplay};
  font-size: 24px;
  color: ${colors.KBNight};
`;

const AppointmentBlockDate = styled.div`
  ${themes.fonts.FoundersGrotesk};
  font-size: 16px;
  color: ${colors.KBNight};
  padding-bottom: 24px;
`;

const AppointmentBlockLocation = styled.div`
  ${themes.fonts.FoundersGrotesk};
  font-size: 16px;
  color: ${colors.KBNight};
`;

const AppointmentBlockLocationBold = styled(AppointmentBlockLocation)`
  font-weight: bold;
`;

const AppointmentBlockContainer = styled.div`
  margin: 0 0 8px 12px;
`;

type AppointmentDetailProps = {
  appointment: AppointmentType;
  clinic: Clinic | null;
  timeSlot: TimeSlot | null;
  patient?: PatientState;
};
const AppointmentDetailBlock = (props: AppointmentDetailProps) => {
  const { appointment, timeSlot, clinic, patient } = props;
  let timeZoneString;

  const formatTime = () => {
    if (!timeSlot) return '';
    // @ts-ignore
    if (patient && patient.isLoggedIn) {
      timeZoneString =
        patient.patient.preferredTimezone || patient.patient.lab?.timeZone || timeSlot.timeZone;
      //@ts-ignore
      return momentInTimeZone(timeSlot.startTime, timeZoneString).format(
        `ddd, MMM D, YYYY [at] h:mma`
      );
    } else {
      //@ts-ignore
      return momentInTimeZone(timeSlot.startTime, timeSlot.timeZone).format(
        `ddd, MMM D, YYYY [at] h:mma`
      );
    }
  };

  return (
    <AppointmentBlock>
      <Content>
        <CalendarIconGroup />
        {timeSlot && (
          <AppointmentBlockContainer>
            <AppointmentBlockTitle>{appointment.name}</AppointmentBlockTitle>
            <AppointmentBlockDate>
              {formatTime()} {timeZoneString}
            </AppointmentBlockDate>
            <AppointmentLocation timeSlot={timeSlot} appointment={appointment} clinic={clinic} />
          </AppointmentBlockContainer>
        )}
      </Content>
    </AppointmentBlock>
  );
};

const AppointmentLocation = (props: {
  timeSlot: TimeSlot;
  appointment: AppointmentType;
  clinic: Clinic | null;
}) => {
  if (props.appointment.virtual && !props.appointment.videoLink) {
    return (
      <AppointmentBlockLocation>
        <AppointmentBlockLocationBold>
          {'Your provider will call you at the selected time.'}
        </AppointmentBlockLocationBold>
      </AppointmentBlockLocation>
    );
  } else if (props.appointment.virtualFert || props.appointment.virtual) {
    return (
      <AppointmentBlockLocation>
        <AppointmentBlockLocationBold>{'Video Consult'}</AppointmentBlockLocationBold>
        {props.timeSlot.videoLink || props.appointment.videoLink}
      </AppointmentBlockLocation>
    );
  } else if (props.clinic) {
    return (
      <AppointmentBlockLocation>
        <AppointmentBlockLocationBold>{props.clinic.name}</AppointmentBlockLocationBold>
        {props.clinic.address}
      </AppointmentBlockLocation>
    );
  } else {
    return null;
  }
};

const CalendarIconGroupContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 6px;
`;

const CalendarIconGroup = () => {
  return (
    <CalendarIconGroupContainer>
      <LeftBracket color={colors.KBYellow} width={13} height={33} />
      <CalendarIcon />
      <RightBracket color={colors.KBYellow} width={13} height={33} />
    </CalendarIconGroupContainer>
  );
};

const mapStateToProps = (state: ReduxState) => ({
  patient: state.patient
});

export default connect(mapStateToProps)(AppointmentDetailBlock);
